const constantRand = () => 0.5;

export function getVisualTestRand(): (() => number) | undefined {
  if (typeof window === 'undefined' || !window.Meticulous?.isRunningAsTest) {
    return undefined;
  }
  return constantRand;
}
